import React from "react";
import { connect } from "formik";
import { compose } from "redux";
import { Grid } from "@material-ui/core";

import { Divider, StyledGridContainer, StyledFormikInputText, StyledHeaderContainer, StyledHeader, StyledTermSheetButonBlue, StyledButtonCentered } from "./section.styles";
import { addExtensionRow, renderExtensions } from "./section.util";

const Extensions = ({ formik }) => {
  const { values, setValues } = formik;
  const prepaymentTypes = values && values.ancillary && values.ancillary.prepaymentTypes ? values.ancillary.prepaymentTypes : [];

  return (
    <Grid container>
      <StyledHeaderContainer item xs={12}>
        <StyledHeader>Extensions</StyledHeader>
      </StyledHeaderContainer>
      <StyledGridContainer item xs={12}>
        <StyledFormikInputText
          name={"extensionTerms.misc"}
          label={"Miscellaneous Notes"}
          variant={"filled"}
          multiline
        />
      </StyledGridContainer>
      {renderExtensions(values, setValues)}
      <StyledTermSheetButonBlue onClick={() => addExtensionRow(values, setValues)}>
        <StyledButtonCentered>
          Add New Extension
        </StyledButtonCentered>
      </StyledTermSheetButonBlue>

      <Divider />
    </Grid>
  );
};

export default compose(connect)(Extensions);
